<template>
    <div
        class="report-page container-fluid page-card admin-weflix-finance-report"
        data-aos="fade-left"
        data-aos-duration="1500"
    >
        <div class="report-tabs-card">
            <div class="report-page-heading">
                <div class="report-page-heading__row">
                    <TitlePage
                        title="Relatório Financeiro"
                        subtitle="Gerencie os relatórios e métricas financeiras"
                        :has-margin="true"
                    />
                    <div class="report-page-heading__actions">
                        <div class="form-group form-group-finance">
                            <div class="form-input finance-report">
                                <input
                                    type="text"
                                    class="form-control searchFinanceReport"
                                    placeholder="Pesquisar..."
                                    v-model="searchText"
                                    @input="filterReports"
                                />
                                <fa icon="fa-magnifying-glass" />
                            </div>
                            <button
                                class="btnSearch btnSearchFinanceReport"
                                @click="searchClient"
                            >
                                <span v-if="!isMobile">Buscar</span>
                                <fa v-if="isMobile" icon="fa-magnifying-glass" />
                            </button>
                        </div>
                        <button
                            class="btnExport usersExport"
                            @click="exportarRelatorioParaCSV"
                        >
                            <div>
                                <fa icon="fa-download" />
                            </div>
                            <LoaderImage v-show="isExporting" />
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="report-shell">
            <div class="report-stack">
                <div class="report-subpanel report-subpanel--stats" v-if="hasReady">
        <div class="cardsContainer">
            <div class="row report-finance-stats">
                <div class="card-md">
                    <div class="contentCard">
                        <h3 v-if="hasReady">
                            R$
                            <strong>{{
                                total.toLocaleString('pt-BR', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })
                            }}</strong>
                        </h3>
                        <p v-if="hasReady">Vendas</p>
                        <LoaderImage :hasReady="hasReady" />
                    </div>
                </div>
                <div class="card-md">
                    <div class="contentCard">
                        <h3 v-if="hasReady">
                            R$
                            <strong>{{
                                (available_amount / 100).toLocaleString(
                                    'pt-BR',
                                    {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    }
                                )
                            }}</strong>
                        </h3>
                        <p v-if="hasReady">Saldo Atual</p>
                        <LoaderImage :hasReady="hasReady" />
                    </div>
                </div>

                <div class="card-md">
                    <div class="contentCard">
                        <h3 v-if="hasReady">
                            R$
                            <strong>{{
                                (waiting_funds_amount / 100).toLocaleString(
                                    'pt-BR',
                                    {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    }
                                )
                            }}</strong>
                        </h3>
                        <p v-if="hasReady">Saldo Futuro</p>
                        <LoaderImage :hasReady="hasReady" />
                    </div>
                </div>

                <div class="card-md">
                    <div class="contentCard">
                        <h3 v-if="hasReady">
                            R$
                            <strong>{{
                                (transferred_amount / 100).toLocaleString(
                                    'pt-BR',
                                    {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    }
                                )
                            }}</strong>
                        </h3>
                        <p v-if="hasReady">Total de Saídas</p>
                        <LoaderImage :hasReady="hasReady" />
                    </div>
                </div>
            </div>
        </div>
                </div>

                <div class="report-subpanel report-subpanel--table">
        <v-table class="custom-table">
            <thead>
                <tr>
                    <th @click="ordenar('name')">
                        Nome
                        <i
                            :class="[
                                'fas',
                                ordemAtual === 'name'
                                    ? ordemAscendente
                                        ? 'fa-sort-up'
                                        : 'fa-sort-down'
                                    : 'fa-sort',
                            ]"
                        ></i>
                    </th>
                    <th @click="ordenar('speed')">
                        Produto
                        <i
                            :class="[
                                'fas',
                                ordemAtual === 'speed'
                                    ? ordemAscendente
                                        ? 'fa-sort-up'
                                        : 'fa-sort-down'
                                    : 'fa-sort',
                            ]"
                        ></i>
                    </th>
                    <th @click="ordenar('length')" v-if="!isMobile">
                        Data
                        <i
                            :class="[
                                'fas',
                                ordemAtual === 'length'
                                    ? ordemAscendente
                                        ? 'fa-sort-up'
                                        : 'fa-sort-down'
                                    : 'fa-sort',
                            ]"
                        ></i>
                    </th>
                    <th @click="ordenar('length')" style="width: 100px">
                        Valor
                        <i
                            :class="[
                                'fas',
                                ordemAtual === 'length'
                                    ? ordemAscendente
                                        ? 'fa-sort-up'
                                        : 'fa-sort-down'
                                    : 'fa-sort',
                            ]"
                        ></i>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(report, index) in filteredReports" :key="index">
                    <td>{{ report.nameBuyer }}</td>
                    <td>
                        {{ saleTypeLabel(report) }}
                    </td>
                    <td v-if="!isMobile">
                        {{ formatReportDate(reportDate(report)) }}
                    </td>
                    <td>
                        R$
                        {{
                            Number(report.total).toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })
                        }}
                    </td>
                </tr>
            </tbody>
        </v-table>
        <div v-if="loading" class="loading">Carregando mais dados...</div>
                </div>
            </div>
        </div>

        <Loader :hasReady="hasReady && hasReadySearch" />
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import reports from '@/utils/Weflix/reports';
    import Loader from '@/components/Weflix/Loader.vue';
    import LoaderImage from '@/components/Weflix/LoaderImage.vue';
    import TitlePage from '@/components/Weflix/titlePage.vue';

    export default {
        data() {
            return {
                headers: [
                    { title: 'Nome', align: 'start', key: 'name' },
                    { title: 'Speed (knots)', align: 'end', key: 'speed' },
                    { title: 'Length (m)', align: 'end', key: 'length' },
                ],
                reports: [],
                filteredReports: [],
                searchText: '',
                ordemAtual: 'name',
                ordemAscendente: true,
                isMobileIcon: false,
                currentPage: 0,
                loading: false,
                hasMoreData: true,
                available_amount: 0,
                waiting_funds_amount: 0,
                transferred_amount: 0,
                total: 0,
                hasReady: false,
                hasReadySearch: true,
                isExporting: false,
                financeExport: [],
                isMobile: false,
            };
        },
        computed: {
            ...mapState(['token', 'websites']),
        },
        components: {
            Loader,
            LoaderImage,
            TitlePage,
        },
        mounted() {
            this.checkScreenSize();
            window.addEventListener('resize', this.checkScreenSize);
            this.isMobile = window.innerWidth <= 600;
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.checkScreenSize);
        },
        methods: {
            isCoursePurchase(report) {
                const planType = report?.planType;
                const hasPlan = planType !== null && planType !== undefined && planType !== '';
                return !hasPlan && Boolean(report?.idCourse || report?.courseName);
            },
            saleTypeLabel(report) {
                if (this.isCoursePurchase(report)) {
                    return 'Compra';
                }
                return report?.planType ? report.planType : 'Assinatura';
            },
            reportDate(report) {
                if (this.isCoursePurchase(report)) {
                    return report?.dateExpired || report?.dateApproved;
                }
                return report?.dateApproved;
            },
            formatReportDate(value) {
                if (!value) return '';
                const date = new Date(value);
                if (Number.isNaN(date.getTime())) return '';
                return date.toLocaleDateString('pt-BR');
            },
            async exportarRelatorioParaCSV() {
                if (this.isExporting) return;

                this.isExporting = true;

                try {
                    await this.getReportFinanceExport();

                    if (
                        !this.financeExport ||
                        this.financeExport.length === 0
                    ) {
                        console.error('Nenhum cliente para exportar');
                        return;
                    }
                    const cabecalho = [
                        'ID',
                        'Nome do Comprador',
                        'Website',
                        'Código do Pagamento',
                        'Tipo de Plano',
                        'Tipo de Pagamento',
                        'Status',
                        'Data de Aprovação',
                        'Data de Expiração',
                        'Data de Cancelamento',
                        'Data de Inserção',
                        'Cupom',
                        'Valor Total',
                    ];

                    const linhasCSV = this.financeExport.map((finance) => [
                        finance.id,
                        finance.nameBuyer,
                        finance.nameWebsite,
                        finance.codePayment,
                        this.saleTypeLabel(finance),
                        finance.typePayment,
                        finance.status,
                        finance.dateApproved,
                        finance.dateExpired,
                        finance.dateCancelled || '',
                        finance.dateInsert,
                        finance.titleCupom || '',
                        (Number(finance.total) / 100).toFixed(2),
                    ]);

                    const conteudoCSV = [
                        cabecalho.join(','),
                        ...linhasCSV.map((linha) => linha.join(',')),
                    ].join('\n');

                    const blob = new Blob([conteudoCSV], {
                        type: 'text/csv;charset=utf-8;',
                    });
                    const link = document.createElement('a');
                    const url = URL.createObjectURL(blob);

                    link.setAttribute('href', url);
                    link.setAttribute(
                        'download',
                        'relatorio_clientes_weflix.csv'
                    );
                    link.style.visibility = 'hidden';

                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } catch (error) {
                    console.error('Erro ao exportar CSV:', error);
                } finally {
                    this.isExporting = false;
                }
            },
            filterReports() {
                if (!this.searchText) {
                    this.getReportFinance();
                    return;
                }

                // const searchLower = this.searchText.toLowerCase();
                // this.filteredReports = this.reports.filter(report => {
                //     return report.nameBuyer.toLowerCase().includes(searchLower) ||
                //            (report.planType && report.planType.toString().toLowerCase().includes(searchLower)) ||
                //            new Date(report.dateApproved).toLocaleDateString('pt-BR').includes(searchLower) ||
                //            report.total.toString().includes(searchLower);
                // });
            },
            ordenar(coluna) {
                if (this.ordemAtual === coluna) {
                    this.ordemAscendente = !this.ordemAscendente;
                } else {
                    this.ordemAtual = coluna;
                    this.ordemAscendente = true;
                }

                this.boats.sort((a, b) => {
                    let comparacao = 0;
                    if (a[coluna] < b[coluna]) comparacao = -1;
                    if (a[coluna] > b[coluna]) comparacao = 1;
                    return this.ordemAscendente ? comparacao : -comparacao;
                });
            },
            checkScreenSize() {
                this.isMobileIcon = window.innerWidth <= 600;
            },
            async getReportFinance() {
                if (this.loading || !this.hasMoreData) return;

                try {
                    this.loading = true;
                    const response = await reports.getReportFinance(
                        this.token,
                        this.currentPage
                    );
                    this.available_amount =
                        response.recipientReturn?.available_amount || 0;
                    this.waiting_funds_amount =
                        response.recipientReturn?.waiting_funds_amount || 0;
                    this.transferred_amount =
                        response.recipientReturn?.transferred_amount || 0;
                    this.total = response.recipientReturn?.total || 0;

                    if (response.orders.content.length === 0) {
                        this.hasMoreData = false;
                        return;
                    }

                    this.reports = [
                        ...this.reports,
                        ...response.orders.content,
                    ];
                    this.filteredReports = this.reports;
                    this.currentPage++;

                    if (!this.hasReady) {
                        this.hasReady = true;
                    }
                } catch (error) {
                    console.error('Erro ao obter relatório financeiro:', error);
                } finally {
                    this.loading = false;
                }
            },
            async getReportFinanceExport() {
                try {
                    const response = await reports.getReportFinanceExport(
                        this.token
                    );
                    this.financeExport = response.orders.content;
                    this.isExporting = false;
                } catch (error) {
                    console.error('Erro ao obter relatório financeiro:', error);
                }
            },

            handleScroll(e) {
                const container = e.target;
                const scrollPosition =
                    container.scrollTop + container.clientHeight;
                const totalHeight = container.scrollHeight;

                if (scrollPosition > totalHeight * 0.8 && !this.loading) {
                    this.getReportFinance();
                }
            },
            async searchClient() {
                this.hasReadySearch = false;
                const payload = {
                    search: this.searchText,
                };
                try {
                    const response = await reports.getReportFinanceBySearch(
                        this.token,
                        0,
                        payload
                    );
                    this.reports = response.content;
                    this.filteredReports = this.reports;
                    this.hasReadySearch = true;
                } catch (error) {
                    console.error('Erro ao buscar usuários:', error);
                }
            },
        },
        created() {
            this.getReportFinance();
        },
    };
</script>

<style scoped>
    @import url(./global.css);

    .report-page.container-fluid.page-card {
        background: #f4f5f8;
        border-radius: 16px;
        padding: 0 0 1rem;
        box-shadow: 0 1px 3px rgba(37, 8, 145, 0.06);
    }

    .report-tabs-card {
        padding: 1rem;
    }

    .report-page-heading {
        padding: 1rem 1.1rem;
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 14px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    }

    .report-page-heading__row {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 1rem;
        flex-wrap: wrap;
    }

    .report-page-heading__actions {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 12px;
        flex-shrink: 0;
    }

    .report-page-heading :deep(.titlelayoutGeneric) {
        margin: 0 !important;
        padding: 0 !important;
        border-bottom: none !important;
    }

    .report-shell {
        padding: 0 1.5rem 1.5rem;
        height: calc(100vh - 210px);
        overflow-y: auto;
        min-height: 0;
        box-sizing: border-box;
        scrollbar-width: none;
        -ms-overflow-style: none;
    }

    .report-shell::-webkit-scrollbar {
        display: none;
    }

    .report-stack {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        width: 100%;
        max-width: 100%;
    }

    .report-subpanel {
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 14px;
        padding: 1.25rem 1.35rem 1.5rem;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
        min-height: 0;
    }

    .report-subpanel--stats {
        padding-top: 1rem;
        padding-bottom: 1.25rem;
    }

    .report-subpanel--stats .card-md {
        background: #f4f6fa;
        border: 1px solid #e8eaf0;
        box-shadow: none;
    }

    .report-subpanel--table {
        padding-bottom: 1.35rem;
    }

    .cardsContainer {
        margin: 0;
    }

    .report-finance-stats.row {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        margin: 0;
        padding: 0;
        gap: 10px;
        justify-content: space-evenly;
    }

    .report-subpanel--stats .report-finance-stats .card-md {
        width: auto;
        flex: 1 1 22%;
        min-width: 140px;
        max-width: 100%;
    }

    .btnExport {
        width: auto;
        padding: 6px 12px;
        background-color: white;
        border: 1px solid #250891;
        color: #250891;
        border-radius: 5px;
        top: 20px;
        right: 20px;
        cursor: pointer;
        transition: all 500ms ease-in-out;
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .btnExport:hover {
        background-color: #250891;
        color: white;
    }
    .card-md {
        width: 24%;
        padding: 0;
        margin: 0;
        padding: 10px;
        box-shadow: -1px 4px 10px 1px #dfdfdf;
        border-radius: 5px;
        align-items: center;
        display: flex;
        justify-content: center;
    }
    .form-input.finance-report svg.svg-inline--fa.fa-magnifying-glass {
        color: #250891;
        position: absolute;
        top: 9px;
        right: 9px;
    }
    .form-input {
        position: relative;
    }
    input.form-control {
        padding-right: 33px !important;
    }
    .actionsHeader {
        display: flex;
        align-items: center;
    }
    svg.svg-inline--fa.fa-download {
        color: #250891;
        padding: 0px 10px;
        transition: all 500ms ease-in-out;
    }
    .btnExport:hover svg.svg-inline--fa.fa-download {
        color: white;
    }
   
    .loading {
        text-align: center;
        padding: 10px;
        color: #666;
    }
    @media (max-width: 600px) {
        .report-subpanel--stats .report-finance-stats .card-md {
            flex: 1 1 45%;
            min-width: 0;
        }
        .btnExport {
            padding: 7px 7px !important;
        }
        .btnExport svg {
            color: #250891;
        }
        .btnExport:hover svg {
            color: white;
        }

        .report-page-heading__row {
            flex-direction: column;
            align-items: stretch;
        }

        .report-page-heading__actions {
            width: 100%;
            justify-content: flex-start;
        }
    }
    .btnSearch {
        width: auto;
        padding: 6px 12px;
        background-color: white;
        border: 1px solid #250891;
        color: #250891;
        border-radius: 5px;
        cursor: pointer;
        transition: all 500ms ease-in-out;
        margin-left: 10px;
    }
    .btnSearch:hover {
        background-color: #250891;
        color: white;
    }
    button.btnExport.usersExport .loader2 {
        width: 19px;
        aspect-ratio: 1;
        border-radius: 50%;
        border: 2px solid #250891;
        animation: l20-1-79f4614c 0.8s infinite linear alternate,
            l20-2-79f4614c 1.6s infinite linear;
        margin: 0px 10px;
        position: initial;
    }
    button.btnExport.usersExport {
        display: inline-flex;
    }
    .form-group.form-group-finance {
        margin: 0;
        width: auto !important;
    }
    .contentCard {
        position: relative;
        min-height: 70px;
    }
    @media (max-width: 600px) {
        .contentCard h3 {
            font-size: 20px;
        }
        .contentCard p {
            font-size: 11px;
        }
        .contentCard {
            min-height: 50px !important;
        }
    }
    button.btnSearch svg.svg-inline--fa.fa-magnifying-glass {
        color: #250891;
    }

    input.form-control.searchFinanceReport {
        height: 38px !important;
        padding: 6px 12px !important;
        border: 1px solid #250891 !important;
        border-radius: 5px !important;
        font-size: 14px !important;
        width: 250px !important;
    }

    button.btnSearch.btnSearchFinanceReport {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        background-color: white;
        color: #250891;
        cursor: pointer;
        transition: all 300ms ease-in-out;
        white-space: nowrap;
        padding: 0;
        height: 38px;
        padding: 6px 12px;
        border: 1px solid #250891;
        border-radius: 5px;
        font-size: 14px;
    }

    .form-input.finance-report {
        margin: 0;
    }
    .form-group.form-group-finance {
        display: flex;
    }

    .report-page-heading__actions .form-group-finance {
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;
    }
    button.btnExport.usersExport {
        padding: 6px 0;
    }

    .tableContainer {
        margin-top: 10px;
    }
    @media (max-width: 600px) {
        .btnSearch {
            width: auto !important;
            min-width: 44px;
        }

        .actionsHeader {
            display: flex;
            align-items: center;
            width: 100%;
            overflow: hidden;
        }
        input.form-control.searchFinanceReport {
            width: 100%;
            max-width: 100%;
        }
        .form-input.finance-report {
            flex: 1;
            min-width: 0;
        }

        .report-page-heading__actions .form-group-finance {
            flex: 1;
            min-width: 0;
        }
    }

    @media (max-width: 768px) {
        .report-shell {
            padding: 0 1rem 1.25rem;
        }

        .report-subpanel {
            padding: 1rem;
        }

        .report-page-heading {
            padding: 0.85rem 1rem;
        }
    }
</style>
